import * as React from 'react';
import classNames from 'classnames';
import { prefixCls } from '../../utils';
import './Fieldset.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FieldSet = ({
  className,
  title,
  description,
  children
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(`${prefixCls}-fieldset`, className),
    children: [/*#__PURE__*/_jsx("div", {
      className: `${prefixCls}-fieldset-title`,
      children: title
    }), !!description && /*#__PURE__*/_jsx("div", {
      className: `${prefixCls}-fieldset-description`,
      children: description
    }), children]
  });
};
//# sourceMappingURL=es/FormUI/FieldSet/Fieldset.js.map